import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouteParamsService {
  private paramSource = new BehaviorSubject<any | null>(null);
  currentParam$ = this.paramSource.asObservable();

  updateParam(param: any) {
    this.paramSource.next(param);
  }
}
